import { gql } from '@apollo/client';
const UPDATE_PROJECTION_NAME = gql `
  mutation ChangeModelProjectionName($modelSpecificationProjectionId: ID!, $name: String!) {
    updateModelSpecificationProjection(
      modelSpecificationProjectionId: $modelSpecificationProjectionId
      name: $name
    ) {
      modelSpecificationProjection {
        id
        name
      }
    }
  }
`;
export default UPDATE_PROJECTION_NAME;
